class FormAnswerDataMerger {
  mergeDynamicFormWithResults(dynamicForm, answerDataValues) {
    const mergedLinks = dynamicForm.links.map((link) => {
      return this.mergeLinkWithResults(link, answerDataValues);
    });

    return {
      ...dynamicForm,
      links: mergedLinks,
    };
  }

  mergeLinkWithResults(link, answerDataValues) {
    const mergedShard = this.fetchAnswerDataFromResults(
      link.shard,
      answerDataValues
    );

    const mergedLinks = link.shard.links.map((link) => {
      return this.mergeLinkWithResults(link, answerDataValues);
    });

    return {
      ...link,
      shard: {
        ...mergedShard,
        links: mergedLinks,
      },
    };
  }

  fetchAnswerDataFromResults(shard, answerDataValues) {
    const answerData = answerDataValues.find((data) => data.id === shard.id);

    if (!answerData) return shard;

    return { ...shard, ...answerData };
  }
}

export { FormAnswerDataMerger };
